export const apiKey = "AIzaSyA9SXLscqsL8V87xB16w2q52lO-0yzejDQ";

// export const endpoint = "http://localhost:8080";

export const endpoint = "https://still-refuge-96429.herokuapp.com"


// WEBPACK FOOTER //
// ./src/helpers/config.js